import React, { Component } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import Spinner from "../../Spinner";

class LocationState extends Component {
  state = { selectedState: "", stateRegion: "" };

  handleSelect = (val) => {
    const region = this.props.regions.filter((reg) => reg.id === val.regionID);
    this.setState({ selectedState: val, stateRegion: region[0] });
  };

  customFilter = (option, searchText) => {
    if (option.data.name.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };

  render() {
    return (
      <div>
        {this.props.states.length > 0 ? (
          <div className="row m-0">
            <div className="col-md-12 col-sm-12 pb-5 pl-0 mb_p_0">
              <div className="Header-Content overflow-hidden">
                <h5 className="form_label">States</h5>
              </div>
              <div className="">
                <Select
                  onChange={this.handleSelect}
                  getOptionLabel={(option) => `${option.name} `}
                  getOptionValue={(option) => `${option.id}`}
                  isOptionSelected={(option) => {
                    return this.state.selectedState.id === option.id
                      ? true
                      : false;
                  }}
                  options={this.props.states}
                  isSearchable={true}
                  filterOption={this.customFilter}
                  onInputChange={this.handleInputChange}
                  noOptionsMessage={() => null}
                  placeholder={"Search State"}
                  autoFocus={false}
                  menuIsOpen={this.state.menuOpen}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,

                      primary25: "#ffa552",
                      primary50: "#fabc82",
                      primary: "#fcb26d",
                    },
                  })}
                />
              </div>
            </div>
            <div className="col-md-12 col-sm-12 pl-0 locationTableDiv mb_p_0">
              {this.state.selectedState !== "" ? (
                <div className="">
                  <table className="table table-hover tableStyle2">
                    <thead>
                      <tr>
                        <td>State</td>
                        <td>Short Name</td>
                        <td>Region</td>
                        <td>Is Active</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td data-th="State">{this.state.selectedState.name}</td>
                        <td data-th="Short Name">
                          {this.state.selectedState.shortName}
                        </td>
                        <td data-th="Region">{this.state.stateRegion.name}</td>
                        <td data-th="Is Active">
                          {this.state.selectedState.activeFlag === "Y"
                            ? "True"
                            : "False"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {this.props.user.role === "Admin" ? (
                    <div className="row m-0">
                      <div className="col p-0">
                        <Link
                          to={`/masters/state/${this.state.selectedState.id}/city/create`}
                          className="linkBtn1"
                        >
                          Add City
                        </Link>
                        <Link
                          to={`/masters/region/${this.state.stateRegion.id}/state/${this.state.selectedState.id}/edit`}
                          className="linkBtn1"
                        >
                          Modify
                        </Link>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          <Spinner />
        )}
      </div>
    );
  }
}

export default LocationState;
